import { ref } from "vue";

// Native appStateChange is independent of WebView document visibility.
export const chatAppActive = ref(true);

export function canReadChat({ active, visible, focused, following, accessible }) {
    return active && visible && focused && following && accessible;
}
